// extracted by mini-css-extract-plugin
module.exports = {"text":"MediaBlock_text__93iMM"};